import { makeContextModule } from '@cian/react-utils';

import { IAppContext } from '../../types';

export const {
  Context: AppContext,
  useContext: useAppContext,
  withContext: withAppContext,
} = makeContextModule<IAppContext>({
  contextName: 'ApplicationContext',
  defaultValue: {} as IAppContext,
});
